import { render } from "./LoadingOverlay.vue?vue&type=template&id=412b85c8"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=412b85c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__